export default __webpack_public_path__ + "static/media/photoprofil3.5e3698de.png";